/**
 * Detects the Internet Explorer Version below IE11 in one function.
 */
function detectVersion() {
    let result;
    const $html = document.documentElement;
    const isIE11 = ('-ms-scroll-limit' in $html.style) && ('-ms-ime-align' in $html.style) && document.documentMode;
    
    result = (function() {
        /*@cc_on switch(@_jscript_version) {case 1.0: return 3; case 3.0: return 4; case 5.0: return 5; case 5.1: return 5; case 5.5: return 5.5; case 5.6: return 6; case 5.7: return 7; case 5.8: return 8; case 9: return 9; case 10: return 10;} @*/
        return 0;
    }());
    result = document.documentMode || (isIE11 ? 11 : result);
    
    addDetectionClasses($html, result);
    
    return result;
};

/**
 * Adds IE detection classes to an element
 */
function addDetectionClasses($el, version) {
    switch (version) {
        case (3):
        case (4):
        case (5):
        case (5.5):
        case (6):
        case (7):
            $el.className += ' lt-ie8 lt-msedge';
            break;
        case (8):
            $el.className += ' ie8 lt-msedge';
            break;
        case (9):
            $el.className += ' ie9 lt-msedge';
            break;
        case (10):
            $el.className += ' ie10 lt-msedge';
            break;
        case (11):
            $el.className += ' ie11 lt-msedge';
            break;
        default:
            break;
    }
}


export const version = detectVersion();



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/util/fixes/ie-detect/index.js